// extracted by mini-css-extract-plugin
export default {"DrawerNamesInput":"DrawerNames_DrawerNamesInput__7LYQ+"};